import { render, staticRenderFns } from "./ecommerce.vue?vue&type=template&id=00dc5df1&scoped=true&"
import script from "./ecommerce.vue?vue&type=script&lang=js&"
export * from "./ecommerce.vue?vue&type=script&lang=js&"
import style0 from "./ecommerce.vue?vue&type=style&index=0&id=00dc5df1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dc5df1",
  null
  
)

export default component.exports